import { render, staticRenderFns } from "./SavedAnchorPage.vue?vue&type=template&id=d647e1fe&scoped=true"
import script from "./SavedAnchorPage.vue?vue&type=script&lang=js"
export * from "./SavedAnchorPage.vue?vue&type=script&lang=js"
import style0 from "./SavedAnchorPage.vue?vue&type=style&index=0&id=d647e1fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d647e1fe",
  null
  
)

export default component.exports